import React, { useEffect, useState, useLayoutEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Box, Hidden } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb } from './';
import { profileService } from '../../service';

import { useGetAllChainsQuery, useGetStationsByChainQuery } from '../../apis/backend';
import { loadingChains, loadedChains, loadingSites, loadedSites, selectChain, selectSite, setLanguage } from '../../slices/chainSiteSelector';

const useStyles = makeStyles(() => ({
  select: {
    height: 28,
    fontSize: 14,
    lineHeight: '20px',
    backgroundColor: '#FFFFFF',
  },
  selectRoot: {
    paddingTop: 5,
    paddingBottom: 5,
  },
  selectContainer: {
    width: 200,
    '&:nth-child(2)': {
      marginLeft: 10,
    }
  },
  breadcrumbContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  }
}));

const ChainStationSelector = () => {
  const selectedChain = useSelector(state => state.doris.selectedChain);
  const selectedSite = useSelector(state => state.doris.selectedSite);
  const [profile, setProfile] = useState();

  const dispatch = useDispatch();
  const classes = useStyles();

  /* eslint-disable no-unused-vars */
  const { data: chainOptions, isLoading: isLoadingChains, isFetching: isFetchingChains, errorChains } = useGetAllChainsQuery();
  const { data: siteOptions, isLoading: isLoadingSites, isFetching: isFetchingSites, errorSites } = useGetStationsByChainQuery(selectedChain, { skip: !selectedChain});
  /* eslint-enable no-unused-vars */

  useEffect(() => {
    isLoadingChains
      ? dispatch(loadingChains())
      : dispatch(loadedChains());
    isLoadingSites
      ? dispatch(loadingSites())
      : dispatch(loadedSites());
  }, [isLoadingChains, isLoadingSites]);

  const startUp = async () => {
    const profileResponse = await profileService.get();
    const profile = profileResponse.data;
    const lang = profile.preferredLanguage ? profile.preferredLanguage.split('-')[0] : 'fi';
    dispatch(setLanguage(lang));
    setProfile(profile);
  };

  const sortById = (a, b) => a.id - b.id;

  useLayoutEffect(() => {
    startUp();
  }, []);

  useEffect(() => {
    if (!chainOptions || !profile) return;
    if (profile.userType == 'superuser') {
      dispatch(selectChain([...chainOptions].sort(sortById)[0].id));
    } else if (['admin', 'user'].includes(profile.userType) && profile.chainId) {
      dispatch(selectChain(profile.chainId));
    } else {
      console.error('User lacks chainId profile attribute');
    }
  }, [chainOptions, profile, dispatch]);

  useEffect(() => {
    if (siteOptions?.length) {
      const siteId = [...siteOptions].sort(sortById)[0].id;
      dispatch(selectSite(siteId));
    }
  }, [siteOptions, dispatch]);

  return (
    <Box className={classes.breadcrumbContainer}>
      <Hidden smUp={true}>
        <MenuIcon />
      </Hidden>
      <Hidden xsDown={true}>
        { chainOptions?.length > 0 && (<Box className={classes.selectContainer}>
          <SmallSelectField
            value={selectedChain || ''}
            options={chainOptions}
            onChange={event => {
              const chainId = event.target.value;
              dispatch(selectSite(''));
              dispatch(selectChain(chainId));
            }} />
        </Box>) }
        { siteOptions?.length && selectedSite ? (<Box className={classes.selectContainer}>
          <SmallSelectField
            value={selectedSite || ''}
            options={siteOptions}
            onChange={event => {
              const siteId = event.target.value;
              dispatch(selectSite(siteId));
            }} />
        </Box>) : '' }
      </Hidden>
      <Hidden mdDown={true}>
        <Breadcrumb />
      </Hidden>
    </Box>
  );
};


const SmallSelectField = ({ value, onChange, options }) => {
  const classes = useStyles();
  return (
    <Select
      value={value}
      onChange={onChange}
      className={classes.select}
      classes={{ root: classes.selectRoot }}
      variant='outlined'
      fullWidth>
      {options.map(option => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ChainStationSelector;
